import React from 'react';
import './TermsAndConditions.css';

// --- MODIFICATION: Receive the 'onBack' function as a prop ---
const TermsAndConditions = ({ onBack }) => {
  return (
    <div className="terms-container">
      <h1>Terms of Service and Privacy Policy</h1>
      <p>Last updated: July 20, 2025</p>

      <p>
        These terms and conditions outline the rules and regulations for the use of the AI Offer Assistant service provided by Planifyit GmbH.
      </p>

      <hr />

      <h2>Terms of Service</h2>

      <h3>1. Acceptance of Terms</h3>
      <p>
        By accessing and using our AI Offer Assistant, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.
      </p>

      <h3>2. Description of Service</h3>
      <p>
        The service provides an interactive AI assistant to collect information from you through a voice conversation. The purpose is to generate a personalized offer based on the details you provide.
      </p>

      <h3>3. User Conduct</h3>
      <p>
        You agree to use this service only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the service.
      </p>

      <hr />

      <h2>Privacy Policy</h2>
      <p>
        Your privacy is important to us. This privacy statement explains the personal data Planifyit GmbH processes, how we process it, and for what purposes.
      </p>

      <h3>1. Data Controller</h3>
      <p>
        The responsible entity for data collection and processing (the "Data Controller") is:
        <br />
        <strong>Planifyit GmbH</strong>
        <br />
        Av. de Tivoli 3, 1700 Fribourg, Switzerland
        <br />
        CHE-231.157.006
        <br />
        Email: contact@planifyit.com
      </p>

      <h3>2. Data We Collect</h3>
      <p>
        By using the AI Offer Assistant, you willingly provide and consent to the collection of the following data:
      </p>
      <ul>
        <li>
          <strong>Personal Information:</strong> Any personal details you verbally provide during the conversation, such as your name, contact information, or specific requirements related to the offer.
        </li>
        <li>
          <strong>Audio Recordings:</strong> The full audio file of your conversation with the AI assistant.
        </li>
      </ul>

      <h3>3. Purpose of Data Collection</h3>
      <p>
        Your data is collected and stored for the sole and explicit purposes of:
      </p>
      <ul>
        <li>Generating the personalized offer you have requested.</li>
        <li>Storing the generated offer and related information for future reference.</li>
        <li>Contacting you with promotional information directly related to the offer you have shown interest in.</li>
      </ul>
      <p>
        Your data will not be used for any other purpose or shared with third parties without your explicit consent.
      </p>
      
      <h3>4. Legal Basis for Processing</h3>
       <p>
        We process your personal data based on your explicit consent, which you provide by choosing to use our service and accepting these terms. This processing is necessary for the fulfillment of the service requested by you, in accordance with Art. 6(1)(a) and Art. 6(1)(b) of the GDPR and the relevant provisions of the Swiss Federal Act on Data Protection (FADP).
      </p>

      <h3>5. Your Data Protection Rights</h3>
      <p>
        In accordance with the EU General Data Protection Regulation (GDPR) and the Swiss Federal Act on Data Protection (FADP), you have the following rights regarding your data:
      </p>
      <ul>
        <li><strong>The right to access</strong> – You have the right to request copies of your personal data.</li>
        <li><strong>The right to rectification</strong> – You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete.</li>
        <li><strong>The right to erasure</strong> – You have the right to request that we erase your personal data, under certain conditions.</li>
        <li><strong>The right to restrict processing</strong> – You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
        <li><strong>The right to object to processing</strong> – You have the right to object to our processing of your personal data, under certain conditions.</li>
        <li><strong>The right to data portability</strong> – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
      </ul>
      <p>
        To exercise any of these rights, please contact us at our email: <strong>contact@planifyit.com</strong>. We will respond to your request within one month.
      </p>

      {/* --- MODIFICATION: Use onClick to trigger the onBack function --- */}
      <button onClick={onBack} className="back-button">
        Go Back
      </button>
    </div>
  );
};

export default TermsAndConditions;
